export default {
  buttonTitle: {
    en: 'Learn more',
  },
}
